<div class="flex w-full">
    <mat-icon 
        matTooltip="View Details" 
        class="material-icons-outlined" 
        [class.disabled]="isDisabled"
        (click)="onClick()"
    >
        description
    </mat-icon>
</div>